import React from 'react';
import LogFormShell from './LogFormShell';

const NaturalCaptureComposerShell = ({
  open,
  onClose,
  title = 'Log update',
  subtitle = 'Capture anything from today. We’ll organize it for review.',
  child = null,
  children,
  footer = null,
  bodySx = {},
  sheetSx = {},
  hideHeader = false,
  forceDrawer = false,
}) => {
  const childLabel = String(child?.name || '').trim();

  return (
    <LogFormShell
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      titleBadge={childLabel || null}
      compactTitle
      titleWeight={700}
      titleSx={{
        fontSize: { xs: '1.78rem', sm: '2rem' },
        lineHeight: 1.1,
        letterSpacing: 0,
        color: '#1A2320',
      }}
      subtitleSx={{
        mt: 1,
        fontSize: { xs: '1rem', sm: '1.06rem' },
        lineHeight: 1.35,
        color: '#7A8A84',
      }}
      titleBadgeSx={{
        height: 40,
        borderRadius: '999px',
        bgcolor: '#eef5f2',
        border: 'none',
        color: '#5f907f',
        fontSize: '0.98rem',
        fontWeight: 800,
        '& .MuiChip-label': {
          px: 1.2,
        },
      }}
      closeButtonSx={{
        width: 42,
        height: 42,
        bgcolor: '#f0f4f2',
        border: 'none',
        color: '#8b9d96',
        '&:hover': {
          bgcolor: '#e7eeeb',
        },
      }}
      closeIconSx={{
        color: '#8b9d96',
        fontSize: 22,
      }}
      mobileBreakpoint="lg"
      maxWidth={false}
      forceDrawer={forceDrawer}
      hideHeader={hideHeader}
      headerSx={{
        px: { xs: 3, sm: 4 },
        pt: { xs: 1.4, sm: 2 },
        pb: { xs: 0.75, sm: 1 },
        borderBottom: 'none',
      }}
      bodySx={{
        px: { xs: 3, sm: 4 },
        pt: { xs: 0.5, sm: 0.75 },
        pb: { xs: 2, sm: 2.5, md: 3 },
        ...bodySx,
      }}
      surfaceSx={{
        border: 'none',
        boxShadow: 'none',
        bgcolor: 'background.paper',
        overflow: 'hidden',
        borderRadius: 0,
        borderTopLeftRadius: { xs: 10, sm: 10 },
        borderTopRightRadius: { xs: 10, sm: 10 },
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        height: { xs: '86vh', md: 'min(88dvh, 88vh)' },
        maxHeight: { xs: '86vh', md: 'min(88dvh, 88vh)' },
        ...(sheetSx || {}),
      }}
      footer={footer}
    >
      {children}
    </LogFormShell>
  );
};

export default NaturalCaptureComposerShell;
